module.exports = __webpack_public_path__ + "assets/img/编组 9@2x (8).2c5580b8.png";